<template>
  <div style="background-color: #edf4fc;padding-bottom: 0.2rem;">
    <div class="content-title">
      <span style="font-size: 0.3rem; line-height: 0.6rem">中国MBA考前俱乐部</span>
    </div>
    <div class="science-press">
      <img src="@/assets/mbaclub.jpg" alt="中国MBA考前俱乐部" style="display: block;margin: 0 auto;width: 9rem;">
      <p class="science-press-p">北京博雅爱文教育科技有限公司，立足服务MBA高校，服务MBA导师，服务MBA培训机构，服务MBA备考生源和MBA，EMBA群体，从事教育，创新创业，高校研发项目与企业对接，招聘猎头，金融平台，银行业务等。</p>
      <p class="science-press-p">中国MBA考前俱乐部隶属于<span style="color: red;">北京博雅爱文教育科技有限公司</span>，前身是北京MBA考前俱乐部，随着服务备考考生区域的扩展，影响力的增强，在中国MBA联盟第十一届陈希光主席，北京MBA联盟第十一届董惜如主席的指导下发展成中国MBA考前俱乐部。俱乐部的发展得到了北京和其他地区众多MBA高校导师的大力支持和帮助。中国MBA考前俱乐部是第一个全方位为中国MBA考生服务的平台，还得到了MBA辅导机构的热情参与和交流，很多MBA、EMBA同学的帮助和推广。</p>
      <p class="science-press-p"><span style="color: red;">▷缴费地址：</span>北京市海淀区中关村科贸大厦1810 010-82672597</p>
      <p class="science-press-p"><span style="color: red;">▷缴费地址：</span>北京航空航天大学 工程训练中心 010-89943118</p>
      <p class="science-press-p"><span style="color: red;">▷缴费地址：</span>北京市海淀区北四环中路229号海泰大厦1007室 010-62343910</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市海淀区苏州街长远天地大厦A1座19层  刘老师010-82621297 18611750310</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市朝阳区东三环中路39号建外soho西区14号楼506室 010-58698175 17718384387</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市海淀区知春路7号北航至真大厦D座4层 18810236810 田老师</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市安贞大厦1805室 韦老师010-57250661 13520248106</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市朝阳北土城西路11号城建开发大厦东座6层  楚老师18201001716</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市海淀区学院路30号天工大厦908室 刘老师010-62216098 13501072946</p>
      <p class="science-press-p"><span style="color: rgb(22, 1, 1);">▶合作伙伴地址：</span>北京市海淀区科贸大厦19层 孔老师 18010168836</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  data() {
    return {
    }
  },
  created() {
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.content-title {
  text-align: center;
  color: #303133;
  height: 0.6rem;
  background-color: rgb(188, 247, 220);
}
.science-press {
  margin: 0.2rem;
}
.science-press-p {
  font-size: 0.15rem;
  text-indent: 0.3rem;
  text-align:justify;
  line-height: 1.6;
}
</style>
